import React, { Component } from 'react'
import PlaceHolder from 'components/PlaceHolder';

import './CardVehicle.scss'

export default class CardVehiclePlaceholder extends Component {
    render() {
        return (
            <div id={this.props.id ? this.props.id : undefined} className='CardVehicle'>
                <a rel="noreferrer nofollow" className='CardVehicle__link'>
                    <figure>
                        <PlaceHolder />
                    </figure>
                    <div className='CardVehicle__details'>
                        <div className='CardVehicle__details__header'>
                            <h2 className="CardVehicle__details__header__title"><PlaceHolder /></h2>
                            <h3 className="CardVehicle__details__header__description"><PlaceHolder /></h3>
                        </div>
                        <div className='CardVehicle__details__content'>
                            <strong className={"CardVehicle__details__content__price"}><PlaceHolder /></strong>
                        </div>

                        <div className='CardVehicle__details__specification'>
                            <span className="CardVehicle__details__specification__year">{<PlaceHolder width="px" px="50" />}</span>
                            <span className="CardVehicle__details__specification__km">{<PlaceHolder width="px" px="56" />}</span>
                        </div>
                        <div className='CardVehicle__details__footer'>
                            <span className="CardVehicle__details__footer__state"><PlaceHolder /></span>
                        </div>
                    </div>
                </a>
            </div>
        )
    }
}
